export default "__VITE_ASSET__2efe1cc1__"